import { call } from 'redux-saga/effects'

import { debateSaga } from 'modules/debate'

export default function* saga() {
  yield [call(debateSaga)]
}



// WEBPACK FOOTER //
// ./client/modules/app/saga.js